import React, { useEffect, useState } from 'react'
import { Card, Col, List, Row, Space, Spin, Tag, Typography } from 'antd'
import getTotalTeamCount from 'api/dashboard/getTotalTeamCount'
import uuid4 from 'uuid4'

import style from './style.module.scss'

interface PropType {
	clientId: string | undefined
}
const { Title } = Typography
const TotalNoOfTeams: React.FC<PropType> = ({ clientId }) => {
	const [active, setActive] = useState(0)

	const [InActive, setInActive] = useState(0)

	const [teamList, setTeamList] = useState<
		Array<{ _id: string | null; teamName: string | undefined; active: boolean }>
	>([])
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		const getTeamData = async () => {
			setLoading(true)

			try {
				const response = await getTotalTeamCount({ client: clientId || undefined })
				setActive(
					clientId
						? response.filter(ele => {
								return ele._id.active === true
						  }).length || 0
						: response.find(ele => ele._id.active)?.count || 0
				)

				setInActive(
					clientId
						? response.filter(ele => {
								return ele._id.active === false
						  }).length || 0
						: response.find(ele => ele._id.active === false)?.count || 0
				)
				setTeamList(
					clientId
						? response.map(ele => {
								return {
									_id: uuid4(),
									teamName: ele._id.teamName,
									active: ele._id.active,
								}
						  }) || []
						: []
				)

				setLoading(false)
			} catch (error: any) {
				setLoading(false)
			}
		}
		getTeamData()
	}, [clientId])
	return (
		<Spin spinning={loading}>
			<Card className={style.layout} title='Teams Stats'>
				<Row justify='space-between'>
					<Col span={4}>
						<Card title='Total teams '>
							<Title level={2}>{active + InActive}</Title>
						</Card>
					</Col>
					<Col span={4}>
						<Card title='Active Teams'>
							<Title level={2}>{active}</Title>
						</Card>
					</Col>
					<Col span={4}>
						<Card title='In-active Teams'>
							<Title level={2}>{InActive}</Title>
						</Card>
					</Col>

					<Col span={10}>
						<Card title='Team List '>
							<List
								size='large'
								bordered
								dataSource={teamList}
								renderItem={item => (
									<List.Item key={item._id}>
										<List.Item.Meta
											title={
												<Space align='end'>
													{item.teamName}{' '}
													<Tag color={item.active ? 'green' : 'red'}>
														{item.active ? 'Active' : 'In-Active'}
													</Tag>
												</Space>
											}
										/>
									</List.Item>
								)}
							/>
						</Card>
					</Col>
				</Row>
			</Card>
		</Spin>
	)
}

export default TotalNoOfTeams
